const PAGE_LOAD_EVENTS = ["DOMContentLoaded", "turbo:load", "turbolinks:load"];

export function onPageLoad(callback) {
  if (document.readyState !== "loading") {
    callback();
  }

  PAGE_LOAD_EVENTS.forEach((eventName) => {
    document.addEventListener(eventName, callback);
  });

  window.addEventListener("pageshow", callback);
}
